import React from 'react';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import HandWithThreePlusSigns from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/darkTheme/HandWithThreePlusSigns.js';
import PersonWithLightbulbWordBubble from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/darkTheme/PersonWithLightbulbWordBubble.js';
import TwoMapPinsConnectedWithCurvyDottedLine from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/darkTheme/TwoMapPinsConnectedWithCurvyDottedLine.js';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';

export const ITEMS = [
  {
    id: 'financial-planning-go-to-financial-expert-link',
    icon: PersonWithLightbulbWordBubble,
    title: 'Better conversations',
    contentAs: 'div',
    content: (
      <Typography
        themeType='darkTheme'
        align='left'
        disableBottomPadding>
        Our financial advisors are expert listeners who ask deeper questions to understand your goals and reveal blind spots and opportunities others might miss.
      </Typography>
    ),
  },
  {
    id: 'financial-planning-wide-range-of-financial-options',
    icon: HandWithThreePlusSigns,
    title: 'Better solutions',
    contentAs: 'div',
    content: (
      <Typography
        themeType='darkTheme'
        align='left'
        disableBottomPadding>
        Our exclusive portfolio of financial products is designed to meet you where you are, at every stage in your life, identifying and addressing any gaps you might have.
      </Typography>
    ),
  },
  {
    id: 'financial-planning-flexibility-to-pivot-link',
    icon: TwoMapPinsConnectedWithCurvyDottedLine,
    title: 'Better outcomes',
    contentAs: 'div',
    content: (
      <Typography
        themeType='darkTheme'
        align='left'
        disableBottomPadding>
        Independent analysis has shown that clients who follow a comprehensive approach to planning experienced better outcomes.<sup>1</sup>
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='financial-planning'
      backgroundVariant='darkDefault'
      headingText={<>What you get when you work <WidowBlock>with us</WidowBlock></>}
      cardDataArray={ITEMS}
    />
  );
};
